import { cn } from "@/modules/lib/utils"
import { Calendar } from "@modules/calendar/calendar"
import { type DetailedSessionType } from "@modules/sessions/sessionsType"
import {
  TrainingCalendarEvent,
  type TrainingCalendarEventType,
} from "@modules/training/components/trainingCalendarEvent"

type TrainingCalendarProps = {
  sessions: TrainingCalendarEventType[]
  onClickOnSlot: (arg: DetailedSessionType) => void
  detailedSessionId?: string
  isLoadingSessions: boolean
} & React.ComponentProps<"div">

export function TrainingCalendar({
  sessions,
  onClickOnSlot,
  detailedSessionId,
  isLoadingSessions,
  className,
  ...props
}: TrainingCalendarProps) {
  return (
    <div className={cn("mt-8 flex grow flex-col items-center bg-surface-background", className)} {...props}>
      <Calendar
        calendarEvents={sessions}
        canAddEvents={false}
        loading={isLoadingSessions}
        customRenderEvent={(index, event) => (
          <TrainingCalendarEvent
            key={index}
            index={index}
            event={sessions.find(
              (session) =>
                session.id === event.id &&
                (("date" in event && "date" in session && event.date === session.date) ||
                  !("date" in event) ||
                  !("date" in session)),
            )}
            onEventClick={onClickOnSlot}
            isDetailsOpen={detailedSessionId === event.id}
          />
        )}
      />
    </div>
  )
}
